import { __values } from 'tslib';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
var LogLevel = {
    NONE: 0,
    CRITICAL: 1,
    ERROR: 2,
    WARNING: 3,
    INFORMATION: 4,
    VERBOSE: 5,
};
LogLevel[LogLevel.NONE] = 'NONE';
LogLevel[LogLevel.CRITICAL] = 'CRITICAL';
LogLevel[LogLevel.ERROR] = 'ERROR';
LogLevel[LogLevel.WARNING] = 'WARNING';
LogLevel[LogLevel.INFORMATION] = 'INFORMATION';
LogLevel[LogLevel.VERBOSE] = 'VERBOSE';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GenericLogger = /** @class */ (function () {
    function GenericLogger(type) {
        this.type = type;
    }
    /**
     * @param {?} level
     * @param {?} message
     * @param {?=} error
     * @return {?}
     */
    GenericLogger.prototype.log = /**
     * @param {?} level
     * @param {?} message
     * @param {?=} error
     * @return {?}
     */
    function (level, message, error) {
        log(this.type, level, message, error);
    };
    /**
     * @param {?} messageOrError
     * @param {?=} error
     * @return {?}
     */
    GenericLogger.prototype.error = /**
     * @param {?} messageOrError
     * @param {?=} error
     * @return {?}
     */
    function (messageOrError, error) {
        /** @type {?} */
        var message = /** @type {?} */ (messageOrError);
        if (messageOrError && (/** @type {?} */ (messageOrError)).message) {
            message = (/** @type {?} */ (messageOrError)).message;
            error = (/** @type {?} */ (messageOrError)); // eslint-disable-line tslint/config
        }
        else if (messageOrError && (/** @type {?} */ (messageOrError)).code && (/** @type {?} */ (messageOrError)).defaultMessage) {
            /** @type {?} */
            var err = /** @type {?} */ (messageOrError);
            message = err.code + ": " + err.defaultMessage;
        }
        log(this.type, LogLevel.ERROR, message, error);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    GenericLogger.prototype.warn = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        log(this.type, LogLevel.WARNING, message);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    GenericLogger.prototype.info = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        log(this.type, LogLevel.INFORMATION, message);
    };
    return GenericLogger;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var appenderFactories = {};
/** @type {?} */
var session;
/** @type {?} */
var appenders = [];
/** @type {?} */
var appenderConfigs;
/**
 * @param {?} type
 * @param {?} level
 * @param {?} message
 * @param {?=} error
 * @return {?}
 */
function log(type, level, message, error) {
    var e_1, _a;
    try {
        /** @type {?} */
        var record = {
            type: type,
            level: level,
            message: message,
            error: error,
            time: new Date(),
            session: session
        };
        try {
            for (var appenders_1 = __values(appenders), appenders_1_1 = appenders_1.next(); !appenders_1_1.done; appenders_1_1 = appenders_1.next()) {
                var appender = appenders_1_1.value;
                appender.append(record);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (appenders_1_1 && !appenders_1_1.done && (_a = appenders_1.return)) _a.call(appenders_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    catch (err) {
        if (typeof console !== 'undefined') {
            console.error(err); // eslint-disable-line no-console
        }
    }
}
/** @type {?} */
var loggerFactory = {
    createLogger: /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        return new GenericLogger(type);
    },
    addAppenderFactory: /**
     * @param {?} appenderFactory
     * @return {?}
     */
    function (appenderFactory) {
        appenderFactories[appenderFactory.appenderId] = appenderFactory;
        if (appenderConfigs && appenderFactory.appenderId in appenderConfigs) {
            appenders.push(appenderFactory.create(appenderConfigs[appenderFactory.appenderId]));
        }
    },
    config: /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var e_2, _a;
        appenders = [];
        appenderConfigs = {};
        try {
            for (var _b = __values(config.appenders), _c = _b.next(); !_c.done; _c = _b.next()) {
                var configEntry = _c.value;
                appenderConfigs[configEntry.appenderId] = configEntry.config;
                if (configEntry.appenderId in appenderFactories) {
                    appenders.push(appenderFactories[configEntry.appenderId].create(configEntry.config));
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    },
    sessionInformation: /**
     * @param {?=} currentSession
     * @return {?}
     */
    function (currentSession) {
        session = currentSession;
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var defaultConfig = {
    appenders: [{
            appenderId: 'console',
            config: {
                minimumLogLevel: LogLevel.VERBOSE,
                includeType: true
            }
        }]
};
/**
 * Creates LoggerLoggerConfig object.
 * @param {?=} logAppenders
 * @param {?=} useAppenderIds
 * @return {?} Result object
 */
function getConfig(logAppenders, useAppenderIds) {
    if (useAppenderIds === void 0) { useAppenderIds = ['console']; }
    if ((logAppenders && logAppenders.length > 0) && (useAppenderIds && useAppenderIds.length > 0)) {
        return {
            appenders: logAppenders.filter(function (a) { return useAppenderIds.indexOf(a.appenderId) !== -1; })
        };
    }
    return defaultConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ConsoleLogAppender = /** @class */ (function () {
    function ConsoleLogAppender(config) {
        this.config = config;
    }
    /**
     * @param {?} record
     * @return {?}
     */
    ConsoleLogAppender.prototype.append = /**
     * @param {?} record
     * @return {?}
     */
    function (record) {
        if (!console) {
            return;
        }
        getConsoleMethod(record).apply(console, formatRecord(this.config, record));
    };
    return ConsoleLogAppender;
}());
/**
 * @param {?} config
 * @param {?} record
 * @return {?}
 */
function formatRecord(config, record) {
    /** @type {?} */
    var result = [];
    var type = record.type, error = record.error, message = record.message;
    if (config.includeType && type) {
        result.push("[" + type + "] ");
    }
    if (error) {
        if (message !== error.message) {
            result.push(message, error);
        }
        else {
            result.push(error);
        }
    }
    else {
        result.push(message);
    }
    return result;
}
/**
 * @param {?} record
 * @return {?}
 */
function getConsoleMethod(record) {
    /** @type {?} */
    var result = console.log;
    if (record.error || record.level <= LogLevel.ERROR) {
        result = console.error;
    }
    else if (record.level === LogLevel.WARNING) {
        result = console.warn;
    }
    else if (record.level === LogLevel.INFORMATION) {
        result = console.info;
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MinLevelAppenderDecorator = /** @class */ (function () {
    function MinLevelAppenderDecorator(appender, minLevel) {
        this.appender = appender;
        if (typeof minLevel !== 'number') {
            minLevel = /** @type {?} */ ((LogLevel[minLevel] || LogLevel.NONE)); // eslint-disable-line tslint/config
        }
        this.minLevel = minLevel;
    }
    /**
     * @param {?} record
     * @return {?}
     */
    MinLevelAppenderDecorator.prototype.append = /**
     * @param {?} record
     * @return {?}
     */
    function (record) {
        /** @type {?} */
        var level = record.level === undefined ? LogLevel.NONE : record.level;
        if (level <= this.minLevel) {
            this.appender.append(record);
        }
    };
    return MinLevelAppenderDecorator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ConsoleLogAppenderFactory = /** @class */ (function () {
    function ConsoleLogAppenderFactory() {
        this.appenderId = 'console';
    }
    /**
     * @param {?} config
     * @return {?}
     */
    ConsoleLogAppenderFactory.prototype.create = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return new MinLevelAppenderDecorator(new ConsoleLogAppender(config), config.minimumLogLevel);
    };
    return ConsoleLogAppenderFactory;
}());

var _a;
var NetworkLogAppender = /** @class */ (function () {
    function NetworkLogAppender(config) {
        this.url = config.apiUrl;
    }
    /**
     * @param {?} record
     * @return {?}
     */
    NetworkLogAppender.prototype.append = /**
     * @param {?} record
     * @return {?}
     */
    function (record) {
        var session = record.session, type = record.type, message = record.message, error = record.error, level = record.level, time = record.time;
        if (!session || !session.idToken || !this.url) {
            // no session or token or url, cannot log via network.
            return;
        }
        /** @type {?} */
        var payload = {
            loggingType: type,
            message: message,
            exceptionType: error && error.name,
            exceptionMessage: error && error.message,
            exceptionStackTrace: error && error.stack,
            createdOn: time.toISOString(),
            logLevel: (function (level) { return NetworkLogAppender.logLevelMap[level] || 0 /* Trace */; })(level),
        };
        /** @type {?} */
        var xhr = new XMLHttpRequest();
        xhr.open('POST', this.url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Authorization', "Bearer " + session.idToken);
        xhr.send(JSON.stringify(payload));
    };
    NetworkLogAppender.logLevelMap = (_a = {},
        _a[LogLevel.VERBOSE] = 1 /* Debug */,
        _a[LogLevel.INFORMATION] = 2 /* Info */,
        _a[LogLevel.WARNING] = 3 /* Warn */,
        _a[LogLevel.ERROR] = 4 /* Error */,
        _a[LogLevel.CRITICAL] = 5 /* Fatal */,
        _a);
    return NetworkLogAppender;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NetworkLogAppenderFactory = /** @class */ (function () {
    function NetworkLogAppenderFactory() {
        this.appenderId = 'network';
    }
    /**
     * @param {?} config
     * @return {?}
     */
    NetworkLogAppenderFactory.prototype.create = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return new MinLevelAppenderDecorator(new NetworkLogAppender(config), config.minimumLogLevel);
    };
    return NetworkLogAppenderFactory;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { loggerFactory, getConfig, ConsoleLogAppenderFactory, NetworkLogAppenderFactory, MinLevelAppenderDecorator, LogLevel };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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